import { render, staticRenderFns } from "./afasContactInput.vue?vue&type=template&id=1017e771&"
import script from "./afasContactInput.vue?vue&type=script&lang=js&"
export * from "./afasContactInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports